import React, { ReactElement, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { trySilentRefresh } from "@/api/session";

type GateState = "loading" | "authed" | "anon";

type Props = {
  authedRedirectTo?: string;
};

export const AuthAwareFallbackRoute = ({
  authedRedirectTo = "/404",
}: Props): ReactElement => {
  const [state, setState] = useState<GateState>("loading");

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (localStorage.getItem("token")) {
        if (!cancelled) setState("authed");
        return;
      }
      const ok = await trySilentRefresh();
      if (!cancelled) setState(ok ? "authed" : "anon");
    }

    void run();

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "loading") return <></>;
  if (state === "authed") return <Navigate to={authedRedirectTo} replace />;
  return <Navigate to="/login" replace />;
};

